import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./UserProfie";
import userActionReducer from "./UserActions";
import themeReducer from "./Thems";
import scrollTracking from "./ScrollTracking";

export const store = configureStore({
  reducer: {
    user: userReducer,
    userAction: userActionReducer,
    theme: themeReducer,
    scrollTrack: scrollTracking,
  },
});
